// Libraries
import React, {CSSProperties, ReactNode} from 'react'
// Components
import {Alert, ComponentColor, IconFont} from '@influxdata/clockface'

interface Props {
  style: CSSProperties
  children?: ReactNode
}

export const DangerAlert = ({children, style}: Props): JSX.Element => {
  return (
    <Alert
      color={ComponentColor.Danger}
      icon={IconFont.AlertTriangle}
      style={style}
    >
      {children}
    </Alert>
  )
}
